import React from "react";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { useSelector } from "react-redux";

export const DataPoints = () => {
  const dataPoints = useSelector((state) => state.draft.chartsData.dataPoints);
  const { qa, currencySymbol } = useSelector((state) => state.commonReducer.commonProps);

  if (!dataPoints || !dataPoints.length) return null;

  return (
    <div className="data-points">
      {dataPoints.map(({ label, value, type, url }) => {
        const isMoney = type === "money";
        const isPercent = type === "percent";

        return (
          <div key={label} className="data-point">
            <DataDisplay
              disableAnimation={qa}
              label={label}
              value={value}
              type={isMoney ? "money" : isPercent ? "percentage" : "default"}
              currency={isMoney ? currencySymbol : isPercent ? "%" : ""}
              decimal={isMoney ? 2 : 0}
              showDecimal={isPercent}
              toFixedValue={isPercent ? 1 : undefined}
              url={url || ""}
            />
          </div>
        );
      })}
    </div>
  );
};
